import React, { useEffect, useState } from "react";
import { Layout, Modal, Tooltip, Button, Typography } from "antd";
import { CloseOutlined, ZoomInOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useMedia } from "react-media";
import { useIntl } from "react-intl";
import PatientDetails from "../../scheduling/components/PatientDetails";
import ActionsTable from "../../../components/templates/ActionsTable";
import FullName from "../../../components/tables/FullName";
import { useLocation } from "react-router-dom";
import SchedulingModal from "./SchedulingModal";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { listPatientSchedulingHistory } from "../../../api/server";
import { loadHistory, reset } from "../../scheduling/schedulingSlice";
import moment from "moment";
import EmployeeStatus from "../../../components/tables/EmployeeStatus";

const { Text } = Typography;

const GLOBAL_MEDIA_QUERIES = {
  small: "(max-width: 899px)",
};

const HistoryModal = (props) => {
  const { visible, onHide } = props;
  const intl = useIntl();
  let location = useLocation();
  let { branchId } = useParams();
  const [employeeSchedulingRecord, setEmployeeSchedulingRecord] =
    useState(null);

  const matches = useMedia({ queries: GLOBAL_MEDIA_QUERIES });
  const activePatient = useSelector(
    (state) => state.patientDetails.activePatient
  );
  const { historyPage: page } = useSelector((state) => state.scheduling);
  const { current, pageSize, total } = page;
  const [scopePrefix, setScopePrefix] = useState(null);

  const closeModal = () => {
    onHide();
  };

  const onShowEmployeeScheduling = (record) => {
    setEmployeeSchedulingRecord(record);
  };

  const closeEmployeeSchedulingModal = () => {
    setEmployeeSchedulingRecord(null);
  };

  useEffect(() => {
    setScopePrefix(branchId ? `branches/${branchId}/` : ``);
  }, [branchId]);
  const { isLoading, data } = useQuery(
    [page, scopePrefix, activePatient],
    async () => {
      const params = {
        ...page,
        scopePrefix,
        patientId: activePatient.id,
        query: { from: moment().subtract(10, "years").format() },
      };
      const result = await listPatientSchedulingHistory(params);
      return result.data;
    },
    {
      keepPreviousData: true,
      staleTime: 0,
      enabled:
        activePatient &&
        activePatient.id !== undefined &&
        scopePrefix !== null &&
        visible === true,
    }
  );

  const branchPath = location.pathname.substring(
    0,
    location.pathname.lastIndexOf("/")
  );

  return (
    <Modal
      width={"vw"}
      style={{
        height: "100vh",
        maxWidth: "100vw",
        position: "absolute",
        top: 0,
        left: 0,
      }}
      styles={{
        body: {
          height: "100vh",
          width: "100vw",
          padding: "10px",
        },
      }}
      className={"no-padding no-border-radius"}
      closable={false}
      open={visible}
      footer={null}
      destroyOnClose={true}
    >
      <Layout
        style={{
          background: "transparent",
          paddingTop: "20px",
        }}
      >
        {matches.small ? null : (
          <div style={{ position: "absolute", left: "10px", top: "10px" }}>
            <PatientDetails record={activePatient} />
          </div>
        )}
        <Tooltip title="close">
          <Button
            onClick={closeModal}
            size="large"
            style={{ position: "absolute", right: 10, top: 10 }}
            shape="circle"
            icon={<CloseOutlined />}
          />
        </Tooltip>
        <div style={{ marginTop: "40px" }}>
          <ActionsTable
            borderless={true}
            scroll={window.innerHeight - 196}
            tableItems={[
              {
                title: "month",
                render: ({ record }) => {
                  return (
                    <Link
                      style={{ color: "inherit", textDecoration: "underline" }}
                      to={{
                        pathname: location.pathname + "/" + activePatient.id,
                        state: {
                          activeTab: "scheduling",
                          month: record["month"],
                          year: record["year"],
                        },
                      }}
                    >
                      {`${record["month"]}/${record["year"]}`}
                    </Link>
                  );
                },
              },
              {
                title: "employee_name",
                render: ({ record }) => {
                  return (
                    <FullName
                      record={{
                        first_name: record.employee_first_name,
                        surename: record.employee_surename,
                        id: record.employee_id,
                      }}
                      customLocation={`${branchPath}/employees/${record.employee_id}`}
                    />
                  );
                },
              },
              {
                title: "employee_local_id_number",
              },
              {
                title: "status",
                render: ({ record }) => {
                  return (
                    <EmployeeStatus
                      record={{
                        status_id: record.status,
                      }}
                      text={record.status}
                    />
                  );
                },
              },
              {
                title: "client",
                responsive: ["xl"],
                render: ({ record }) => {
                  return <Text>{record["client_name"]}</Text>;
                },
              },
              {
                title: "duration_minutes",
                render: ({ record }) => {
                  return (
                    <Text>
                      {Math.round((record.duration_minutes / 60) * 100) / 100}
                    </Text>
                  );
                },
              },
              {
                title: "actions",
                responsive: ["md"],
                width: "130px",
                render: ({ record }) => (
                  <Tooltip
                    title={intl.formatMessage({
                      id: "app.sheduling.showScheduling",
                    })}
                  >
                    <Button
                      type="text"
                      icon={<ZoomInOutlined />}
                      onClick={() => onShowEmployeeScheduling(record)}
                    />
                  </Tooltip>
                ),
              },
            ]}
            category={"scheduling"}
            current={current}
            pageSize={pageSize}
            total={total}
            loading={isLoading}
            loadPage={loadHistory}
            resetPage={reset}
            items={data && data.items ? data.items : []}
          />
        </div>
      </Layout>
      <SchedulingModal
        employeeSchedulingRecord={employeeSchedulingRecord}
        closeEmployeeSchedulingModal={closeEmployeeSchedulingModal}
        scopePrefix={scopePrefix}
      />
    </Modal>
  );
};

export default HistoryModal;
